import React, { useState, useEffect } from "react";

import {fetchStockTechnicals} from "../../api";

import Plot from "react-plotly.js";
import Stockchart from "../stockchart_plotly";

const CandlestickChart = ({ data }) => {
  return (
    // <Plot
    //   data={[
    //     {
    //       x: data.candlestick.map((d, i) => i),
    //       open: data.candlestick.map(d => d.Open),
    //       high: data.candlestick.map(d => d.High),
    //       low: data.candlestick.map(d => d.Low),
    //       close: data.candlestick.map(d => d.Close),
    //       type: "candlestick",
    //       name: "Candlestick",
    //     },
    //     {
    //       x: data.candlestick.map((d, i) => i),
    //       y: data.ema_50,
    //       type: "scatter",
    //       mode: "lines",
    //       name: "EMA 50",
    //       line: { color: "blue" },
    //     },
    //     {
    //       x: data.candlestick.map((d, i) => i),
    //       y: data.ema_200,
    //       type: "scatter",
    //       mode: "lines",
    //       name: "EMA 200",
    //       line: { color: "red" },
    //     },
    //   ]}
    //   layout={{ title: "Candlestick Chart with EMA", xaxis: { title: "Time" }, yaxis: { title: "Price" } }}
    // />
      <Stockchart symbol={data} volume={true} bbFlag={true} levelFlag={true}/>

  );
};

// const MomentumIndicators = ({ data }) => {
//   return (
//     <Plot
//       data={[
//         {
//           x: data.rsi.map((_, i) => i),
//           y: data.rsi,
//           type: "scatter",
//           mode: "lines",
//           name: "RSI",
//           line: { color: "purple" },
//         },
//         {
//           x: data.macd.map((_, i) => i),
//           y: data.macd,
//           type: "scatter",
//           mode: "lines",
//           name: "MACD",
//           line: { color: "green" },
//         },
//         {
//           x: data.signal.map((_, i) => i),
//           y: data.signal,
//           type: "scatter",
//           mode: "lines",
//           name: "Signal Line",
//           line: { color: "red" },
//         },
//       ]}
//       layout={{ title: "Momentum Indicators (RSI, MACD)", xaxis: { title: "Time" }, yaxis: { title: "Value" } }}
//     />
//   );
// };

const MomentumIndicators = ({ data }) => {
  return (
    <div className="momentum-container">
      <h2>Momentum Indicators</h2>

      {/* RSI with Overbought/Oversold Zones */}
      <Plot
        data={[
          {
            x: data.rsi.map((_, i) => i),
            y: data.rsi,
            type: "scatter",
            mode: "lines",
            name: "RSI",
            line: { color: "purple" },
          },
          {
            x: data.rsi.map((_, i) => i),
            y: Array(data.rsi.length).fill(70),
            type: "scatter",
            mode: "lines",
            name: "Overbought (70)",
            line: { color: "red", dash: "dot" },
          },
          {
            x: data.rsi.map((_, i) => i),
            y: Array(data.rsi.length).fill(30),
            type: "scatter",
            mode: "lines",
            name: "Oversold (30)",
            line: { color: "green", dash: "dot" },
          }
        ]}
        layout={{ title: "RSI with Overbought & Oversold Zones", xaxis: { title: "Time" }, yaxis: { title: "RSI Value" } }}
      />

      {/* MACD with Histogram */}
      <Plot
        data={[
          {
            x: data.macd.map((_, i) => i),
            y: data.macd,
            type: "scatter",
            mode: "lines",
            name: "MACD",
            line: { color: "blue" },
          },
          {
            x: data.signal.map((_, i) => i),
            y: data.signal,
            type: "scatter",
            mode: "lines",
            name: "Signal Line",
            line: { color: "red" },
          },
          {
            x: data.histogram.map((_, i) => i),
            y: data.histogram,
            type: "bar",
            name: "MACD Histogram",
            marker: { color: data.histogram.map(v => v > 0 ? "green" : "red") },
          }
        ]}
        layout={{ title: "MACD with Histogram", xaxis: { title: "Time" }, yaxis: { title: "MACD Value" } }}
      />

      {/* ADX (Trend Strength Indicator) */}
      <Plot
        data={[
          {
            x: data.adx.map((_, i) => i),
            y: data.adx,
            type: "scatter",
            mode: "lines",
            name: "ADX",
            line: { color: "orange" },
          }
        ]}
        layout={{ title: "ADX (Trend Strength Indicator)", xaxis: { title: "Time" }, yaxis: { title: "ADX Value" } }}
      />

      {/* On-Balance Volume (OBV) */}
      <Plot
        data={[
          {
            x: data.obv.map((_, i) => i),
            y: data.obv,
            type: "scatter",
            mode: "lines",
            name: "OBV",
            line: { color: "brown" },
          }
        ]}
        layout={{ title: "On-Balance Volume (OBV)", xaxis: { title: "Time" }, yaxis: { title: "OBV Value" } }}
      />

      {/* Commentary on Indicators */}
      <div className="insights">
        <h3>Insights:</h3>
        <p><strong>RSI:</strong> Above 70 indicates overbought, below 30 indicates oversold.</p>
        <p><strong>MACD:</strong> Crossovers between MACD and Signal Line indicate buy/sell signals.</p>
        <p><strong>ADX:</strong> Above 25 suggests strong trend; below 20 suggests weak trend.</p>
        <p><strong>OBV:</strong> Rising OBV with price confirms trend; divergence signals reversals.</p>
      </div>
    </div>
  );
};

const FibonacciLevels = ({ data }) => {
  console.log("SR",data)
  // Calculate dynamic Y-axis range
  const prices = data.candlestick.map(d => d.High).concat(data.candlestick.map(d => d.Low));
  const minY = Math.min(...prices) * 0.98; // Slight padding below
  const maxY = Math.max(...prices) * 1.02; // Slight padding above

  return (
    <div className="support-container">
      <h2>Support & Resistance Levels</h2>

      {/* Candlestick Chart with Fibonacci & Pivot Lines */}
      <div align={"center"} style={{height:"700px"}}>
      <Plot
        data={[
          {
            x: data.candlestick.map(d => d.date),
            open: data.candlestick.map(d => d.Open),
            high: data.candlestick.map(d => d.High),
            low: data.candlestick.map(d => d.Low),
            close: data.candlestick.map(d => d.Close),
            type: "candlestick",
            name: "Candlestick",
          },
          ...Object.entries(data.fibonacci_levels).map(([level, value]) => ({
            x: [data.candlestick[0].date, data.candlestick[data.candlestick.length - 1].date],
            y: [value, value],
            mode: "lines+text",
            name: `Fib ${level}`,
            text: [`Fib ${level}`],
            textposition: "top right",
            line: { color: "gold", dash: "dot", width: 2 },
          })),
          ...Object.entries(data.pivot_points).map(([level, value]) => ({
            x: [data.candlestick[0].date, data.candlestick[data.candlestick.length - 1].date],
            y: [value, value],
            mode: "lines+text",
            name: `Pivot ${level}`,
            text: [`Pivot ${level}`],
            textposition: "top right",
            line: { color: "red", dash: "dot", width: 2 },
          }))
        ]}
        layout={{
          title: "Candlestick with Fibonacci & Pivot Levels",
          xaxis: { title: "Dates", rangeslider : {visible : false}},
          yaxis: { title: "Price", range: [minY, maxY] },
          showlegend:false,
        }}
        useResizeHandler={true}  // Automatically resize the chart
        style={{ width: '100%', height: '100%' }}  // Full width/height of container
      config={{ responsive: true }}
      />
      </div>
      {/*/!* Moving Averages Chart *!/*/}
      {/*<Plot*/}
      {/*  data={[*/}
      {/*    {*/}
      {/*      x: data.candlestick.map(d => d.date),*/}
      {/*      y: data.ema_50,*/}
      {/*      type: "scatter",*/}
      {/*      mode: "lines",*/}
      {/*      name: "EMA 50",*/}
      {/*      line: { color: "blue" },*/}
      {/*    },*/}
      {/*    {*/}
      {/*      x: data.candlestick.map(d => d.date),*/}
      {/*      y: data.ema_200,*/}
      {/*      type: "scatter",*/}
      {/*      mode: "lines",*/}
      {/*      name: "EMA 200",*/}
      {/*      line: { color: "red" },*/}
      {/*    },*/}
      {/*  ]}*/}
      {/*  layout={{ title: "Moving Averages", xaxis: { title: "Time" }, yaxis: { title: "Price", range: [minY, maxY] } }}*/}
      {/*/>*/}

      {/* Volume Profile Heatmap */}
      <Plot
        data={[
          {
            x: data.volume_profile.map(item => item["Price Level"]),
            y: data.volume_profile.map(item => item["Volume Price"]),
            type: "bar",
            name: "Volume at Price Level",
            marker: { color: "purple" },
          },
        ]}
        layout={{ title: "Volume Profile", xaxis: { title: "Price" }, yaxis: { title: "Volume" } }}
      />

      {/* Insights */}
      <div className="insights">
        <h3>Insights:</h3>
        <p><strong>Fibonacci & Pivot Levels:</strong> Key retracement levels where price may reverse.</p>
        {/*<p><strong>EMA 50 vs. EMA 200:</strong> EMA 50 crossing above EMA 200 signals a bullish trend; crossing below signals bearish.</p>*/}
        <p><strong>Volume Profile:</strong> High volume at a price level suggests strong support or resistance.</p>
      </div>
    </div>
  );
};

const TrendsTreemap = ({ stockSymbol }) => {
  return (
    <Plot
      data={[
        {
          type: "treemap",
          labels: ["Stock", "Sector Trend", "Industry Trend"],
          parents: ["", "Stock", "Sector Trend"],
          values: [1, 3, 5],
          textinfo: "label+value",
          marker: { colors: ["blue", "green", "red"] },
        },
      ]}
      layout={{ title: `Momentum Trends for ${stockSymbol}` }}
    />
  );
};

const TechnicalAnalysis = ({ stockSymbol }) => {
  const [technicalData, setTechnicalData] = useState(null);
  const subSections = ["Candlestick Chart", "Momentum Indicators", "Support & Resistance"];//, "Trends Treemap"];
  const [activeSubTab, setActiveSubTab] = useState(subSections[0]);

  useEffect(() => {
      fetchStockTechnicals(stockSymbol)
      .then((data) => setTechnicalData(data))
      .catch((error) => console.error("Error fetching technical analysis:", error));
  }, [stockSymbol]);

  if (!technicalData) return <p>Loading technical analysis...</p>;

  const renderContent = () => {

    switch (activeSubTab) {
      case "Candlestick Chart":
        return technicalData ? (<div align={"center"} style={{height:"700px"}}>
      <CandlestickChart data={stockSymbol} />
            </div>) : (
                <p>Loading data...</p>
              );
      case "Momentum Indicators":
        return technicalData ? (<div align={"center"} style={{height:"700px"}}>
            <MomentumIndicators data={technicalData}/>
                </div>): (
                <p>Loading data...</p>
              );
      case "Support & Resistance":
        return technicalData ? (<div align={"center"}>
      <FibonacciLevels data={technicalData} />
                </div>) : (
                <p>Loading data...</p>
              );
      case "Trends Treemap":
        return technicalData ? (<div align={"center"}>
        {/*<Risk data={JSON.parse(data.risk_list)} ticker={data.symbol}/>*/}
        <TrendsTreemap stockSymbol={stockSymbol} />
        </div>) : (
                <p>Loading data...</p>
              );
      default:
        return <div>Select a tab to view content.</div>;
    }
  };


  return (
    <div className="section-container">
      {/* Vertical Sidebar */}
      <div className="sidebar">
        {subSections.map((tab) => (
          <button
            key={tab}
            className={`side-tab ${activeSubTab === tab ? "active" : ""}`}
            onClick={() => setActiveSubTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Display */}
      <div className="content">
        {/*<h2>{activeSubTab}</h2>*/}
        {/*<p>Displaying data for {activeSubTab}...</p>*/}
        {renderContent()}
      </div>
    </div>
  );
};

export default TechnicalAnalysis;
